import EventStream from './EventStream';

export default EventStream;
